import { atom } from 'jotai'

export const loadingProductsState = atom(false)
